import * as core from '../../../../../../../core'

import { query } from './degree-of-change-by-department.query'

export const RESOURCE = {
  payload: {
    alias: 'degree.of.change.by.department',
    description: 'Chart view of degree of change by department',
    name: 'Degree of Change by Department',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
